import React, { InputHTMLAttributes } from "react";
import "./Checkbox.scss";

export type CheckboxProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
};

export const Checkbox: React.FC<CheckboxProps> = (incomingProps) => {
  const { label, className, ...props } = incomingProps;
  const id = props.id ? props.id : label.replace(/ /g, "-");
  const wrapperClasses = ["custom-checkbox"];
  if (className) wrapperClasses.push(className);
  if (props.checked) wrapperClasses.push("checked");
  return (
    <div className={wrapperClasses.join(" ")}>
      <input
        type="checkbox"
        {...props}
        className="custom-checkbox-input"
        id={id}
      />
      <label className="custom-checkbox-label" htmlFor={id}>
        {label}
      </label>
    </div>
  );
};
